__turbopack_context__.v({
  "number": "AnimateNumber-module__GuttTW__number",
});
